<p-toggleswitch
  (onChange)="onSwitch.emit($event.checked)"
  [(ngModel)]="statusValue"
  [disabled]="disabled"
  [styleClass]="classList">
</p-toggleswitch>
